import { useLayoutEffect, useRef } from "react";
import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import NewNavbar from "../components/NewNavbar";
import Home from "../components/Home";
import Historia from "../components/Historia";
import Editorial from "../components/Editorial";
import NewFooter from "../components/Footer";
import Anuncia from "../components/Anuncia";
import Categorias from "../components/Categorias";
import Noticias from "../components/Noticias";
import News from "../components/News";
import Busqueda from "../components/Busqueda";

// Al cambiar de ruta la página vuelve al inicio, como hace un sitio normal.
// Con un router de una sola página el navegador conserva el scroll anterior.
const ScrollAlInicio = () => {
    const { key, pathname } = useLocation();
    const rutaAnterior = useRef(pathname);
    const tipo = useNavigationType();

    // La "key" cambia en cada navegación, incluso al pulsar el enlace de la
    // página en la que ya estás. Con "atrás/adelante" (POP) se deja al
    // navegador restaurar su posición.
    //
    // - Misma página (pulsar de nuevo la sección actual): subida suave.
    // - Página distinta: salto inmediato. El contenido se reemplaza y la
    //   página cambia de altura, y una animación se cortaría a medias.
    useLayoutEffect(() => {
        const mismaPagina = rutaAnterior.current === pathname;
        rutaAnterior.current = pathname;
        if (tipo === 'POP') return;
        window.scrollTo({ top: 0, left: 0, behavior: mismaPagina ? 'smooth' : 'instant' });
    }, [key, pathname, tipo]);

    return null;
};

const Views = () => {
    return (
        <>
            <ScrollAlInicio />
            <NewNavbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/nosotros" element={<Historia />} />
                <Route path="/editorial" element={<Editorial />} />
                <Route path="/anuncia" element={<Anuncia />} />
                {/* <Route path="/categorias" element={<Categorias />} /> */}
                <Route path="/categorias/:id" element={<Categorias />} />
                <Route path="/categorias" element={<Noticias />} />
                <Route path="/noticias/:id" element={<News />} />
                {/* La lupa de la cabecera navega aqui; sin esta ruta la busqueda
                    llevaba a una pagina en blanco. */}
                <Route path="/busqueda/:term" element={<Busqueda />} />

            </Routes>
            <NewFooter />
        </>
    );
};

export default Views;